import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpEventType } from '@angular/common/http';
import { CommonService } from './common.service';

@Injectable()
export class HelperService {

  TeenFree = 'Teen Free';
  JuniorBasic = 'Junior Basic';
  TeenPlus = 'Teen Plus';
  TeenPremium = 'Teen Premium';

  TFA = 'tfa';
  JBA = 'jba';
  TPLA = 'tpla';
  TPA = 'tpa';

  constructor(
    private notificationsService: NotificationsService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private cs: CommonService
  ) { }

  setCollegeLogo(url) {
    return this.setImgURL(url);
  }

  setClubLogo(url) {
    if (!url) {
      return 'https://s3.amazonaws.com/images.totalglobalsports.com/ClubImages/Logos/blank-logo.jpg';
    }

    return this.setImgURL(url);
  }

  setUserPhoto(url) {
    return this.setImgURL(url || 'assets/img/avatars/avatar1.jpg');
  }

  setPhoto(url) {
    if (url) {
      return this.setImgURL(url);
    } else {
      return 'assets/img/avatars/avatar1.jpg';
    }
  }

  setImgURL(url) {
    const adminUrl = 'https://admin.totalglobalsports.com';
    let logoUrl: string;

    if (url.includes('Avatar_Empty.jpg')) {
      logoUrl = 'assets/img/avatars/avatar1.jpg';
    } else {
      if (!url.includes('http')) {
        if (url.includes('~')) {
          logoUrl = url.replace('~', adminUrl);
        } else {
          logoUrl = adminUrl + url;
        }
      } else if (url.includes('https://tgs.')) {
        url = url.replace('https://tgs.', 'https://admin.');
        logoUrl = url;
      } else {
        logoUrl = url;
      }
    }

    return logoUrl;
  }

  setVideoThumbnail(url) {
    return url || 'assets/img/video-thumbnail.jpg';
  }

  alertMessage(status, title, message) {
    if (status === 'success') {
      const toast = this.notificationsService.success(title, message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    } else if (status === 'error') {
      const toast = this.notificationsService.error(title, message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    } else if (status === 'warn') {
      const toast = this.notificationsService.warn(title, message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    }
  }

  starCounter(n: number) {
    if (n > 0) {
      return new Array(n);
    }
    return null;
  }

  nullStarCounter(n: number) {
    if (n < 5) {
      n = 5 - n;
      return new Array(n);
    }
    return null;
  }

  search(data: any[], f): any[] {
    const controls = Object.keys(f).filter(control => f[control]);
    if (controls.length) {
      return data.filter(r => {
        return controls.every(control =>
          control === 'name' ? String(r.firstName + ' ' + r.lastName).toLowerCase().includes(String(f.name).toLowerCase())
            : !isNaN(f[control].toString()) ? +r[control] === +f[control]
              : !!new Date(r[control]).getTime() ? new Date(r[control]).toDateString() === new Date(f[control]).toDateString()
                : String(r[control]).toLowerCase().includes(String(f[control]).toLowerCase())
        );
      });
    } else {
      return data;
    }
  }

  getVideoEmbedUrl(url) {
    const youtubeEmbed = 'https://www.youtube.com/embed/';
    const vimeoEmbed = 'https://player.vimeo.com/video/';
    if (url.includes('www.youtube.com')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(youtubeEmbed + url.toString().split('v=')[1]);
    } else if (url.includes('youtu.be/')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(youtubeEmbed + url.substring(url.lastIndexOf('/') + 1));
    } else if (url.includes('vimeo.com/')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(vimeoEmbed + url.substring(url.lastIndexOf('/') + 1));
    }
  }

  mergeTwoDates(startDate, endDate) {
    if (startDate === null && endDate === null) {
      return null;
    }

    let combinedDate = null;
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const dYear1 = new Date(startDate).getFullYear();
    const dYear2 = new Date(endDate).getFullYear();

    const dMonth1 = new Date(startDate).getMonth();
    const dMonth2 = new Date(endDate).getMonth();

    const monthName1 = monthNames[dMonth1];
    const monthName2 = monthNames[dMonth2];

    const dDate1 = new Date(startDate).getDate();
    const dDate2 = new Date(endDate).getDate();

    if (dYear1 === dYear2) {
      if (dMonth1 === dMonth2) {
        if (dDate1 === dDate2) {
          combinedDate = (monthName1.substr(0, 3) + ' ' + dDate1 + ', ' + dYear1);
        } else {
          combinedDate = (monthName1.substr(0, 3) + ' ' + dDate1 + '-' + dDate2 + ', ' + dYear1);
        }
      } else {
        combinedDate = (monthName1.substr(0, 3) + ' ' + dDate1 + ' - ' + monthName2.substr(0, 3) + ' ' + dDate2 + ', ' + dYear1);
      }
    } else {
      combinedDate = (monthName1.substr(0, 3) + ' ' + dDate1 + ', ' + dYear1 + ' - ' + monthName2.substr(0, 3) + ' ' + dDate2 + ', ' + dYear2);
    }

    return combinedDate;
  }

  shortText30(str) {
    if (str && str.length > 30) {
      return str.substring(0, 30) + '...';
    }
    return str;
  }

  shortText25(str) {
    if (str && str.length > 25) {
      return str.substring(0, 25) + '...';
    }
    return str;
  }

  timeConvert(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  timeConvertNew(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      var zerothInx = +time[0] % 12 || 12; // Adjust hours
      if (zerothInx >= 10) {
        time[0] = zerothInx;
      }
      else {
        time[0] = "0" + zerothInx;
      }
    }
    return time.join(''); // return adjusted time or original string
  }

  convertTo24(time, AMPM) {

    let hours = time.toString().substring(0, 2);
    let min = time.toString().substring(2, 4);
    hours = +hours;
    min = +min;
    if (AMPM === 'PM' && hours < 12) { hours = hours + 12; }
    if (AMPM === 'AM' && hours === 12) { hours = hours - 12; }

    let sHours = hours.toString();
    let sMinutes = min.toString();
    if (hours < 10) { sHours = '0' + sHours; }
    if (min < 10) { sMinutes = '0' + sMinutes; }
    return (sHours + ':' + sMinutes);
  }

  formatPhoneNumberOld(number: string) {
    if (number && number.length > 9 && (!number.includes('(') && !number.includes('-'))) {
      const USNumber = number.match(/(\d{3})(\d{3})(\d{4})/);
      return '(' + USNumber[1] + ')-' + USNumber[2] + '-' + USNumber[3];
    }
    return number;
  }

  formatPhoneNumber(number: string) {
    if (number) {
      // Remove all non-numeric characters
      const cleanedNumber = number.replace(/\D/g, '');
      if (cleanedNumber.length === 10) {
        const USNumber = cleanedNumber.match(/(\d{3})(\d{3})(\d{4})/);
        return '(' + USNumber[1] + ')-' + USNumber[2] + '-' + USNumber[3];
      }
    }
    return number;
  }

  calculateAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getFormattedDate(date) {
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return month + '-' + day + '-' + year;
  }

  getFormattedDateYearFirst(date) {
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  appendZero(n) {
    if (n <= 9) {
      return "0" + n;
    }
    return n;
  }

  getOnlyDateFromDateTime(dateTime) {
    if (dateTime) {
      return dateTime.toString().substring(0, 10);
    }
    return "";
  }

  getAddress(address: string): string {
    if (address != null) {
      return address.replace(/,/g, "-");
    }
    else {
      return address;
    }
  }

  calcTimeAgo(date) {
    var seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    var interval = seconds / 31536000;

    if (interval > 1) {
      if (Math.floor(interval) == 1) {
        return Math.floor(interval) + "1 year ago";
      }
      else {
        return Math.floor(interval) + " years ago";
      }
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      if (Math.floor(interval) == 1) {
        return Math.floor(interval) + "1 month ago";
      }
      else {
        return Math.floor(interval) + " months ago";
      }
    }
    interval = seconds / 86400;
    if (interval > 1) {
      if (Math.floor(interval) == 1) {
        return Math.floor(interval) + "1 day ago";
      }
      else {
        return Math.floor(interval) + " days ago";
      }
    }
    interval = seconds / 3600;
    if (interval > 1) {
      if (Math.floor(interval) == 1) {
        return "an hour ago";
      }
      else {
        return Math.floor(interval) + " hours ago";
      }
    }
    interval = seconds / 60;
    if (interval > 1) {
      if (Math.floor(interval) == 1) {
        return "1 minute ago";
      }
      else {
        return Math.floor(interval) + " minutes ago";
      }
    }
    return Math.floor(seconds) + " seconds ago";
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset()));
  }

  weekDayList: any[] = ["Sunday", "Monday", "Tuesday", "Wednesday",
    "Thursday", "Friday", "Saturday"];

  monthNameList: any[] = ["January", "February", "March", "April",
    "May", "June", "July", "August", "September", "October", "November", "December"];

  getFormattedDayWithDate(date: Date) {
    var weekDay: string = this.weekDayList[date.getDay()];
    const year = date.getFullYear();
    const month = this.monthNameList[date.getMonth()];
    const day = date.getDate().toString().padStart(2, '0');

    return weekDay + ' ' + month + ' ' + day + ', ' + year;
  }

  downloadFileAndDelete(fileName) {
    this.cs.downloadFile(fileName).subscribe(
      (data: any) => {
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            break;
          case HttpEventType.Response:
            const downloadedFile = new Blob([data.body], { type: data.body.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);

            this.cs.deleteFile(fileName).subscribe();

            break;
        }
      }
    );
  }

  getYearsBetween(startYear, endYear): Promise<number[]> {
    return new Promise((resolve, _) => {
      const years: number[] = Array.from({ length: endYear - startYear + 1 }, (v, i) => startYear + i);
      resolve(years);
    });
  }
  getMonthList() {
    const months = [
      { id: 1, name: "January" },
      { id: 2, name: "February" },
      { id: 3, name: "March" },
      { id: 4, name: "April" },
      { id: 5, name: "May" },
      { id: 6, name: "June" },
      { id: 7, name: "July" },
      { id: 8, name: "August" },
      { id: 9, name: "September" },
      { id: 10, name: "October" },
      { id: 11, name: "November" },
      { id: 12, name: "December" },
    ];
    return months;
  }

  convertFirstLetterString(inputString: string) {
    //eg. str = "HELLO" output : str = Hello

    const firstLetter = inputString.charAt(0).toUpperCase();
    const remainingLetters = inputString.slice(1).toLowerCase();
    return firstLetter + remainingLetters;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/helper.service.ts